module.exports = __webpack_public_path__ + "static/media/logo.f54ffb7c.svg";